'use client';

import { twMerge } from '@shared/themes';
import Link from 'next/link';
import type { NavigationTab } from '../PageToolbarWithNavigation/navigationConfig/types';

type SubnavigationItemProps = Omit<NavigationTab, 'id'> & {
  isActive: boolean;
  showDivider: boolean;
  text: string;
  className?: string;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
};

function SubnavigationItem({ href, icon: NavIcon, isActive, showDivider, text, trackName, className, onClick }: SubnavigationItemProps) {
  const classes = twMerge(
    'flex items-center select-none p-2 hover:text-foreground justify-center flex-col gap-0.5 w-full relative',
    isActive ? 'text-foreground' : 'text-foreground-subtle',
    showDivider && 'after:absolute after:right-0 after:top-1/2 after:-translate-y-1/2 after:h-[26px] after:w-px after:bg-container',
    className
  );

  const testId = trackName ? `subnavigation-item-${trackName.toLowerCase().replace(/\s+/g, '-')}` : undefined;

  return (
    <Link href={href} className={classes} data-testid={testId} data-track-name={trackName} onClick={onClick}>
      <NavIcon className={isActive ? 'text-accent-green-foreground' : 'text-inherit'} size="small" data-testid="icon" />
      <h2 className="link-label-explanatory">{text}</h2>
    </Link>
  );
}

export { SubnavigationItem };
